import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from "@mui/material";
import { OmissionsAccordions } from "./OmissionsAccordions";
import { OmissionsCheckboxes } from "./OmissionsCheckboxes";
import { useOmissions } from "./useOmissions";
export const Omissions = ({ sequenceNumber }) => {
    const { omissions, accordionDisplay, NoCategoryText, cardsPerRow } = useOmissions(sequenceNumber);
    return (_jsx(Stack, Object.assign({ gap: accordionDisplay ? 0 : 3 }, { children: 
        // Map the omission categories to the checkbox display.
        omissions.map((category, idx) => !!accordionDisplay ? (
        // Displays the checkboxes in a collapsible accordions.
        _jsx(OmissionsAccordions, { category: category, sequenceNumber: sequenceNumber, cardsPerRow: cardsPerRow }, category.categoryId)) : (
        // Display the omissions as a single list with a header for each category.
        _jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "h2", gutterBottom: true }, { children: category.categoryId === 0 || !category.categoryName ? NoCategoryText : category.categoryName })), _jsx(OmissionsCheckboxes, { category: category, sequenceNumber: sequenceNumber, cardsPerRow: cardsPerRow })] }, category.categoryId))) })));
};
